// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Collapse.module.scss  */
.Collapse-module-Collapse_lhg {
  overflow: hidden;
  transition-timing-function: cubic-bezier(0.66, 0.43, 0.46, 0.89);
  transition-property: height; }
  .Collapse-module-Collapse_lhg-entered {
    overflow: visible; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Collapse/Collapse.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,gEAAgE;EAChE,2BAA2B,EAAE;EAC7B;IACE,iBAAiB,EAAE","sourcesContent":["/*  imported from Collapse.module.scss  */\n.Collapse-module-Collapse_lhg {\n  overflow: hidden;\n  transition-timing-function: cubic-bezier(0.66, 0.43, 0.46, 0.89);\n  transition-property: height; }\n  .Collapse-module-Collapse_lhg-entered {\n    overflow: visible; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
